import script from "./AlphaPostCover.vue?vue&type=script&setup=true&lang=js"
export * from "./AlphaPostCover.vue?vue&type=script&setup=true&lang=js"

import "./AlphaPostCover.vue?vue&type=style&index=0&id=6f206aa6&lang=scss"

const __exports__ = script;

export default __exports__